/**
 * TanStack Query hooks for `trackerity-referral-partner-program`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	trackerityReferralPartnerProgramQueryKeys,
	type CreateTrackerityReferralPartnerProgramBody,
	type ListTrackerityReferralPartnerProgramResponse,
	type TrackerityReferralPartnerProgramRow,
} from "./api";

export function useTrackerityReferralPartnerProgramList(): UseQueryResult<ListTrackerityReferralPartnerProgramResponse, Error> {
	return useQuery({
		queryKey: trackerityReferralPartnerProgramQueryKeys.list(),
		queryFn: list,
	});
}

export function useTrackerityReferralPartnerProgramCreate(): UseMutationResult<TrackerityReferralPartnerProgramRow, Error, CreateTrackerityReferralPartnerProgramBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: trackerityReferralPartnerProgramQueryKeys.all });
		},
	});
}

export function useTrackerityReferralPartnerProgramDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: trackerityReferralPartnerProgramQueryKeys.all });
		},
	});
}
